import { Component } from "@angular/core"
import { TitleService } from "@puntaje/shared/core"

@Component({
    templateUrl: "artezonas.component.html"
})
export class BannersComponent {}
